import AuthSurface from '../components/AuthSurface';
import React, { useState } from 'react';
import { authVisualPreview } from '../lib/authVisualPreview';
import axios from 'axios';
import { ShieldCheck, Loader2, ArrowRight } from 'lucide-react';
import { API_BASE_URL as API_URL } from '../apiBase';
import { useAuth, formatApiError } from '../context/AuthContext';

export default function FirstPasswordChange() {
  const { user, checkAuth, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  async function submit(event) {
    event.preventDefault();
    if (busy) return;
    setError('');
    if (password !== confirm) return setError('As senhas não coincidem.');
    if (password.trim() === current.trim()) return setError('Escolha uma senha diferente da provisória.');
    if (password.trim().length < 10 || !/[A-Za-z]/.test(password) || !/\d/.test(password))
      return setError('Use pelo menos 10 caracteres, incluindo letras e números.');
    setBusy(true);
    try {
      await axios.post(`${API_URL}/api/auth/change-password`, {
        current_password: current, new_password: password,
      }, { withCredentials: true });
      setCurrent(''); setPassword(''); setConfirm('');
      await checkAuth();
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || 'Não foi possível salvar. Tente novamente.');
    } finally { setBusy(false); }
  }
  return (
    <AuthSurface as="main" data-auth-visual={authVisualPreview(user)} className="auth-first-password min-h-screen bg-background px-5 py-8 flex items-center justify-center">
      <section className="auth-first-password-card w-full max-w-md rounded-3xl border border-border bg-card p-6 sm:p-9 shadow-xl" aria-labelledby="first-password-title">
        <div className="flex items-center justify-between mb-7">
          <span className="rounded-2xl bg-primary/10 p-3 text-primary"><ShieldCheck size={26} aria-hidden /></span>
        </div>
        <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-2">Primeiro acesso · Segurança</p>
        <h1 id="first-password-title" className="text-2xl font-semibold tracking-tight text-foreground">Defina sua senha pessoal</h1>
        <p className="mt-3 text-sm text-muted-foreground">Para liberar o painel, substitua a senha provisória por uma senha que só você conheça.</p>
        <p className="mt-2 text-sm text-foreground break-all">{user?.email}</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          {error && <p role="alert" className="rounded-xl bg-destructive/10 p-3 text-sm text-destructive">{error}</p>}
          {[
            ['initial-password', 'Senha provisória recebida', current, setCurrent, 'current-password'],
            ['personal-password', 'Nova senha', password, setPassword, 'new-password'],
            ['confirm-personal-password', 'Confirmar nova senha', confirm, setConfirm, 'new-password'],
          ].map(([id, label, value, setter, autoComplete]) => (
            <div key={id}>
              <label htmlFor={id} className="block text-sm font-medium text-foreground mb-2">{label}</label>
              <input id={id} type="password" value={value} onChange={(e) => setter(e.target.value)}
                autoComplete={autoComplete} required disabled={busy} maxLength={72}
                className="login-aurax__input w-full" />
            </div>
          ))}
          <p className="text-xs text-muted-foreground">Pelo menos 10 caracteres, incluindo letras e números. Não reutilize a senha provisória.</p>
          <button type="submit" className="login-aurax__submit w-full" disabled={busy}>
            {busy ? <Loader2 className="animate-spin" size={18} /> : <>Salvar e acessar o painel <ArrowRight size={18} /></>}
          </button>
          <button type="button" onClick={logout} disabled={busy} className="w-full py-2 text-sm text-muted-foreground hover:text-foreground">Sair da conta</button>
        </form>
      </section>
    </AuthSurface>
  );
}
